import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD
} from "../store/types";
import { RequestPushMsg } from '../other/NotificationFunctions';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, get, update, push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {

    const {
      config,
      paymentSettingsRef
    } = firebase;
  
    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    const usertype = store.getState().auth.profile.usertype;

    if(usertype == 'admin'){
        onValue(paymentSettingsRef, snapshot => {
            const data = snapshot.val(); 
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
          });
    } else { 
        const settings = store.getState().settingsdata.settings;
        let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
        let url = firebase.useEmulators ? firebase.functionUrl('get_providers') : `${host}/get_providers`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (Array.isArray(responseJson)) {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_SUCCESS,
                        payload: responseJson,
                    });
                }else{
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
                });
            });
    }
  };

  export const editPaymentMethods = (data) => async (dispatch) => {
    const {
        paymentSettingsRef,
        settingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    await update(paymentSettingsRef, data);
    if (data && data.cash && typeof data.cash.active === "boolean") {
        await update(settingsRef, { disable_cash: !data.cash.active });
    }
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


const updateWalletByAdmin = async (dispatch, uid, amount, mode) => {
    const {
        walletHistoryRef,
        singleUserRef,
        settingsRef
    } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    const settingsdata = await get(settingsRef);
    const settings = settingsdata.val();
    const snapshot = await get(singleUserRef(uid));

    if (snapshot.val()) {
        const profile = snapshot.val();
        const currentBalance = parseFloat(profile.walletBalance || 0);
        const cleanAmount = Math.abs(parseFloat(amount || 0));
        const nextBalance = parseFloat((mode === "debit" ? currentBalance - cleanAmount : currentBalance + cleanAmount).toFixed(2));
        if (cleanAmount <= 0 || isNaN(cleanAmount)) {
            const error = new Error("Please enter a valid amount.");
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: error.message });
            throw error;
        }
        if (nextBalance < 0) {
            const error = new Error("Wallet balance cannot be below zero.");
            dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: error.message });
            throw error;
        }
        const details = {
            type: mode === "debit" ? "Debit" : "Credit",
            amount: cleanAmount,
            date: new Date().getTime(),
            txRef: mode === "debit" ? "AdminDebit" : "AdminCredit"
        };
        await update(singleUserRef(uid), { walletBalance: nextBalance });
        await push(walletHistoryRef(uid), details);
        dispatch({ type: UPDATE_WALLET_BALANCE_SUCCESS, payload: null });
        if (profile.pushToken) {
            RequestPushMsg(
                profile.pushToken,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title,
                    msg: store.getState().languagedata.defaultLanguage.wallet_updated,
                    screen: 'Wallet'
                }
            );
        }
        return nextBalance;
    }
    const error = new Error("User not found.");
    dispatch({ type: UPDATE_WALLET_BALANCE_FAILED, payload: error.message });
    throw error;
};

export const addToWallet = (uid, amount) => async (dispatch) => {
    return updateWalletByAdmin(dispatch, uid, amount, "credit");
};

export const deductFromWallet = (uid, amount) => async (dispatch) => {
    return updateWalletByAdmin(dispatch, uid, amount, "debit");
};


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false
    });
       
};
